import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Theme from '../ui/Theme';
import Image from '../common/Image';
import { formatDurationSeconds } from '../utils/Utils';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  menuRoot: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    /* identical to box height, or 143% */

    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',

    /* Absolute (dark) */

    color: 'black',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function ChangeJourneyCard(props) {
  const classes = useStyles();
  return (
    <section>
      <Card
        className={classes.root}
        variant="outlined"
        style={{
          borderColor: Theme.palette.secondary.main,
          backgroundColor: Theme.palette.secondary.main,
          cursor: 'pointer',
        }}
      >
        <CardContent style={{ padding: '10px 18px' }}>
          <Grid container justifyContent="flex-start" alignItems="center">
            <Grid item onClick={props.handleOpenGuide}>
              <Image src={props.values?.thumbnail} alt="img" style={{ height: '87px', width: '95px' }} />
            </Grid>
            <Grid item onClick={props.handleOpenGuide} style={{ height: '87px', marginLeft: '20px', width: '50%' }}>
              <Typography
                variant="h6"
                component="h6"
                style={{
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '17px',
                  fontStyle: 'normal',
                  marginTop: '20px',
                }}
              >
                {props.values?.title}
              </Typography>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                style={{
                  fontFamily: 'Montserrat',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  fontSize: '12px',
                  lineHeight: '15px',
                  marginTop: '6px',
                  color: '#6663FF',
                }}
              >
                {formatDurationSeconds(props.values?.duration)}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </section>
  );
}
